// extracted by mini-css-extract-plugin
export default {"appVersion":"app-version__app-version__cluPf","appVersionShort":"app-version__app-version-short__sSRAn"};